import { Grid } from '@elliemae/ds-grid';
import { styled } from '@elliemae/ds-system';

export const SwipeContainer = styled(Grid)`
  transition: height 0.2s;
  overscroll-behavior: none;
  height: 100%;
`;

export const SwipeDrag = styled.div`
  border: none;
  overscroll-behavior: none;
  overflow: auto;
  max-height: 100%;
`;

export const LoaderBox = styled(Grid)`
  transition: height 0.2s;
  overflow: hidden;
`;

export const PositionLoader = styled(Grid)`
  transition: margin 0.2s;
`;
